import config from 'config';
import { handleErrors } from 'api/util';
import { FeedItem, PageResponse } from 'components/context/types';

export async function apiGetAllPublicationsByBusinessIds(
    businessIds: string[],
    page: number,
    limit: number,
    sources: string[]
): Promise<PageResponse<FeedItem>> {
    const sourceFilterParams = createSourceFilters(sources);
    let filters = '';
    if (sourceFilterParams) {
        filters = `&${sourceFilterParams}`;
    }
    const postParams = {
        businessIds
    };
    return await fetch(
        `${config.backendUrl}/publications${createPageAndLimitQueryString(
            page,
            limit
        )}${filters}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postParams)
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}
export async function apiGetAllPublicationsByUserGroup(
    page: number,
    limit: number,
    sources: string[]
): Promise<PageResponse<FeedItem>> {
    const sourceFilterParams = createSourceFilters(sources);
    let filters = '';
    if (sourceFilterParams) {
        filters = `&${sourceFilterParams}`;
    }

    return await fetch(
        `${config.backendUrl}/publications${createPageAndLimitQueryString(
            page,
            limit
        )}${filters}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}
export async function apiGetFeedByListOfBusinessIds(
    businessIds: string[],
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    const postParams = {
        businessIds: businessIds
    };
    return await fetch(
        `${config.backendUrl}/news${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postParams)
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}

export async function apiGetTalentArticle(
    source: string,
    articleId: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/news/${source}/${articleId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}

export async function apiGetAllNewsByUserBusinessIds(
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    return await fetch(
        `${config.backendUrl}/news${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}
export async function apiGetJobsByUserBusinessIds(
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    return await fetch(
        `${config.backendUrl}/jobs${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}
export async function apiGetSocialMediaByUserBusinessIds(
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    return await fetch(
        `${config.backendUrl}/social-media${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}

export async function apiGetSocialMediaByListOfBusinessIds(
    businessIds: String[],
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    const postParams = {
        businessIds
    };
    return await fetch(
        `${config.backendUrl}/social-media${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postParams)
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}

export async function apiGetAppointmentsByUserBusinessIds(
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    return await fetch(
        `${config.backendUrl}/appointments${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}

export async function apiGetAppointmentsByBusinessIds(
    businessIds: string[],
    page: number,
    limit: number
): Promise<PageResponse<FeedItem>> {
    return await fetch(
        `${config.backendUrl}/appointments${createPageAndLimitQueryString(
            page,
            limit
        )}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ businessIds })
        }
    )
        .then(handleErrors)
        .then(response => response.json());
}

export async function apiGetAppointmentArticleById(
    id: string
): Promise<Response> {
    return await fetch(`${config.backendUrl}/appointments/${id}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    }).then(handleErrors);
}

function createPageAndLimitQueryString(page: number, limit: number): string {
    return `?page=${page}&limit=${limit}`;
}

function createSourceFilters(sources: string[]): string {
    return sources.map(s => `source=${s}`).join('&');
}
